import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ImagePlus, RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const BlogCoversButton = () => {
  const [status, setStatus] = useState(null);

  const load = () => axios.get(`${API}/blog/admin/covers`, { headers: auth() }).then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!status?.running) return undefined;
    const id = setInterval(load, 8000);
    return () => clearInterval(id);
  }, [status?.running]);

  const start = async () => {
    const r = await axios.post(`${API}/blog/admin/covers/generate`, {}, { headers: auth() });
    toast.success(r.data.started ? `Création de ${r.data.missing} couverture(s) en cours (≈30 s chacune)` : 'Tous les articles ont déjà une couverture');
    setStatus({ missing: r.data.missing, running: r.data.started });
  };

  if (!status) return null;
  const busy = status.running;
  return (
    <button onClick={start} disabled={busy || !status.missing} data-testid="blog-covers-btn"
      className="flex items-center gap-2 bg-white border border-slate-200 text-slate-700 px-4 py-2.5 rounded-lg hover:bg-slate-50 disabled:opacity-60 transition-colors font-medium">
      {busy ? <RefreshCw className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />}
      {busy ? `Couvertures… (${status.missing} restantes)` : status.missing ? `Couvertures blog (${status.missing})` : 'Couvertures blog ✓'}
    </button>
  );
};
